import AsyncComponentUpdateController from './async_component_update_controller';

export default class extends AsyncComponentUpdateController {
  connect() {
    window.addEventListener('topup-selection-change', this.updateCart);
  }

  disconnect() {
    window.removeEventListener('topup-selection-change', this.updateCart);
  }

  updateCart = async () => {
    try {
      await this.updateComponent({
        componentUrl: this.element.dataset.cartComponentUrl,
        componentSelector: this.isMobile()
          ? '.cart-drawer .cart-layout__cart-wrapper'
          : '.ticket-purchase-layout__sidebar.show-for-medium .cart-layout__cart-wrapper',
        body: {},
      });
    } catch (e) {
      console.error(e);
    }
  };
}
